import { render } from "./LocationWorkingHoursSettings.vue?vue&type=template&id=a4e6cb7a&scoped=true"
import script from "./LocationWorkingHoursSettings.vue?vue&type=script&lang=js"
export * from "./LocationWorkingHoursSettings.vue?vue&type=script&lang=js"

import "./LocationWorkingHoursSettings.vue?vue&type=style&index=0&id=a4e6cb7a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e6cb7a"]])

export default __exports__